import { createRouter, createWebHistory } from 'vue-router'
import KiiviComponent from '../views/KiiviComponent.vue'

const routes = [
  {
    path: '/',
    //path: '/search/:search_query?',
    name: 'KiiviComponent',
    component: KiiviComponent,
    props: route => ({ search_query: route.query.q, tag_search: route.query.tag })
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
